/**
 * 群组通讯录
 * Bai.Zhiming
 * 2019-7-18
 */
angular.module('groupDirectoryModule', [
    'imCreateGroupModule', //创建群聊指令
]).
directive('groupDirectory', ["imService", '$timeout', "createGroupService", "modalDialog", "$q", function(imService, $timeout, createGroupService, modalDialog, $q) {
    return {
        restrict: 'E',
        replace: true,
        scope: false,
        templateUrl: './IM/chatWindow/chatDirectory/groupDirectory/groupDirectory_tpl.html',
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [clickGroupItem description] 选中群组
             * @param  {[type]} group [description] 群组信息
             * @return {[type]}       [description]
             */
            scope.clickGroupItem = function(group) {
                scope.status.selectedGroupId = group.GroupId;
                if (angular.isFunction(scope.fn.selectInfo)) {
                    scope.fn.selectInfo(angular.copy(group));
                }
            };
            /**
             * [editGroupMember description] 管理群成员
             * @param  {[type]} group [description] 群组信息
             * @return {[type]}       [description]
             */
            scope.editGroupMember = function(group) {
                imService.getGroupMember(group.GroupId).then(resp => {
                    getMembersDetail(resp).then(memberList => {
                        scope.status.editGroupInfo = {
                            groupId: group.GroupId,
                            memberList: memberList
                        };
                        scope.status.showCreateGroup = true;
                    });
                });
            };
            /**
             * [quitGroup description] 解散群聊
             * @param  {[type]} item [description] 群组信息
             * @param  {[type]} index [description] 群组下标
             * @return {[type]}      [description]
             */
            scope.destroyGroup = function(item, index) {
                modalDialog.alertType("确定要解散该群吗？", "", "ask", true, () => {
                    imService.destroyGroup(item.GroupId).then(resp => {
                        modalDialog.alertType("解散群组成功", "", "success", false);
                        scope.data.groupList.splice(index, 1);
                        handleReducingGroups(item);
                    }, err => {
                        modalDialog.alertType("解散群组失败，可能发生异常", "", "error", true);
                    });
                })
            }
            /**
             * [modifyGroup description] 修改群资料
             * @param  {[type]} item  [description] 群信息
             * @param  {[type]} index [description] 群下标
             * @return {[type]}       [description]
             */
            scope.modifyGroup = function(item, index) {
                createGroupService.groupInfo(item.Name, item.FaceUrl, item.Introduction, item.Notification).then(groupInfo => {
                    let options = {
                        'GroupId': item.GroupId,
                        'Name': groupInfo.groupName,
                        'Notification': groupInfo.Notification,
                        'Introduction': groupInfo.Introduction,
                        'ShutUpAllMember': 'Off'
                    };
                    if (groupInfo.groupImage) {
                        options.FaceUrl = groupInfo.groupImage;
                    }
                    imService.modifyGroupBaseInfo(options).then(resp => {
                        modalDialog.alertType("修改群资料成功", "", "success", false);
                        $timeout(() => { //修改群组后更新头像
                            imService.getJoinedGroupListHigh(`${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`);
                        }, 400);
                        getGroupList().then(() => {
                            handleReducingGroups(item);
                        });
                    }, err => {
                        if (err.ErrorCode == 10004) {
                            modalDialog.alertType("图片地址过长", err.ErrorCode, "error", 'confirm');
                        } else {
                            modalDialog.alertType("修改资料失败", err.ErrorCode, "error", 'confirm');
                        }
                    });
                });
            }
            /**
             * [quitGroup description] 退群
             * @param  {[type]} item [description] 群组信息
             * @param  {[type]} index [description] 群组下标
             * @return {[type]}      [description]
             */
            scope.quitGroup = function(item, index) {
                modalDialog.alertType("确定要退出该群吗？", "", "ask", true, () => {
                    imService.quitGroup(item.GroupId).then(resp => {
                        modalDialog.alertType("退出群组成功", "", "success", false);
                        scope.data.groupList.splice(index, 1);
                        handleReducingGroups(item);
                    }, err => {
                        modalDialog.alertType("退出群组失败，可能发生异常", "", "error", true);
                    });
                })
            };
            /**
             * [handleReducingGroups description] 处理减少群组后的选择问题
             * @return {[type]} [description] 被减少的群组，主要是退群或者解散群，选中的问题
             */
            function handleReducingGroups(item) {
                if (!scope.status.selectedGroupId || item.GroupId != scope.status.selectedGroupId) return;
                scope.status.selectedGroupId = "";
                scope.fn.selectInfo("groupNoSelected");
            }
            /**
             * [getMemberDetail description] 获取成员详情
             * @param  {[type]} account [description] 成员账号
             * @return {[type]}         [description]
             */
            function getMembersDetail(memberList) {
                let deffer = $q.defer();
                let promises = [];
                memberList.forEach(member => {
                    promises.push(getMemberDetail(member));
                });
                $q.all(promises).then(merberListNew => {
                    deffer.resolve(merberListNew);
                }, () => {
                    deffer.reject();
                });
                return deffer.promise;
            }
            /**
             * [getMemberDetail description] 获取单个成员的详细信息
             * @param  {[type]} member [description] 成员信息
             * @return {[type]}         [description]
             */
            function getMemberDetail(member) {
                let deffer = $q.defer();
                let tag_list = [
                    "Tag_Profile_IM_Nick", //昵称
                    "Tag_Profile_IM_Image" //头像
                ];
                let options = {
                    'To_Account': [member.Member_Account],
                    'TagList': tag_list
                };
                webim.getProfilePortrait(options, resp => {
                    let item = resp.UserProfileItem[0].ProfileItem;
                    let userInfo = member.Member_Account.indexOf("_") > 0 ? member.Member_Account.split("_") : [0, member.Member_Account];
                    deffer.resolve({
                        USERNAME: userInfo[1],
                        TENANTID: userInfo[0],
                        UNAME: item[0].Value,
                        USERHEAD: item[1] ? item[1].Value : ""
                    });
                }, error => {
                    deffer.reject();
                });
                return deffer.promise;
            }
            /**
             * [getGroupList description] 获取群组列表
             * @return {[type]} [description]
             */
            function getGroupList() {
                let deffer = $q.defer();
                scope.loaders = imService.getGroupList(`${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`, 200).then(resp => {
                    scope.data.groupList = resp;
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [dateFormat description] 日期格式化
             * @param  {[type]} time [description]
             * @return {[type]}      [description]
             */
            scope.dateFormat = function(time) {
                return imService.dateFormat(time);
            };
            /**
             * [finishCreate description] 完成创建
             * @return {[type]} [description]
             */
            scope.finishCreate = function() {
                scope.status.showCreateGroup = false;
                getGroupList().then(() => {
                    if (angular.isObject(scope.status.editGroupInfo) && scope.status.editGroupInfo.groupId == scope.status.selectedGroupId) {
                        let group = angular.copy(scope.data.groupList.filter(item => {
                            return item.GroupId == scope.status.selectedGroupId;
                        })[0]);
                        scope.fn.selectInfo(angular.copy(group));
                    }
                    scope.status.editGroupInfo = "";
                });
            };
            /**
             * [cancelCreate description] 取消创建
             * @return {[type]} [description]
             */
            scope.cancelCreate = function() {
                scope.status.editGroupInfo = "";
                scope.status.showCreateGroup = false;
            };
            /**
             * [createGroup description] 创建群聊
             * @return {[type]} [description]
             */
            scope.createGroup = function() {
                scope.status.showCreateGroup = true;
            };
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                let status = {};
                let data = {};
                angular.extend(scope.status, status);
                angular.extend(scope.data, data);
            }
            /**
             * [reloadData description] 重载数据，刷新列表
             * @return {[type]} [description]
             */
            function reloadData() {
                scope.$watch("status.reoladData", (newV, oldV) => {
                    if (!newV) return;
                    getGroupList();
                });
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getGroupList();
                reloadData();
            }
        }
    };
}]);